import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class PochtaLocation
*  ОПС назначения.
*/
export class PochtaLocation extends ActiveModel {

/**
  * postalIndex
  * Почтовый индекс ОПС.
  */
  @ActiveField('')
  postalIndex: string = ''


/**
  * opsId
  * Идентификатор ОПС в API Отправка (если известен на момент снимка).
  */
  @ActiveField()
  opsId?: null | string


/**
  * countryCode
  * Код страны ISO 3166-1 alpha-2.
  */
  @ActiveField()
  countryCode?: string


/**
  * city
  * Населённый пункт.
  */
  @ActiveField()
  city?: null | string


/**
  * address
  * Адрес ОПС одной строкой.
  */
  @ActiveField()
  address?: null | string
}
